import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CrawlLinks } from './crawl_links'
import { tagsRepository } from '../repositories/tags_repository'
import {
  SETS_INDEX_PATH,
  LinkRef,
  NamedItem,
  NamedTag,
  collectPages,
  homeCatalogLinks,
  pokemonHubRootIds,
} from '../lib/internal_links'

const emptyLinks = {
  eras: [] as LinkRef[],
  sets: [] as LinkRef[],
  cards: [] as LinkRef[],
}

const HomeCrawlHub = () => {
  const { t, i18n } = useTranslation()
  const [links, setLinks] = useState(emptyLinks)

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      const roots = pokemonHubRootIds()
      const eras = await collectPages(async page => {
        const response = await tagsRepository.index({
          params: {
            type: 'Category',
            depth: 1,
            limit: 500,
            page,
          },
        })
        return { tags: response.tags as NamedTag[], totalPages: response.pagination.totalPages }
      })
      const pokemonEras = homeCatalogLinks(eras, [], [], i18n.language, roots).eras
      const firstEra = eras.find(era => pokemonEras.some(link => link.href === `/categories/${era.id}`))
      let sampleSets: NamedTag[] = []
      let sampleCards: NamedItem[] = []

      if (firstEra) {
        const setPage = await tagsRepository.index({
          parentId: firstEra.id,
          params: {
            type: 'Category',
            limit: 12,
            page: 1,
            sort: 'release_date_desc',
          },
        })
        sampleSets = setPage.tags as NamedTag[]
        const sampleSet = sampleSets[0]

        if (sampleSet) {
          const cardPage = await tagsRepository.getItems(sampleSet.id, { page: 1, types: [], limit: 8 })
          sampleCards = cardPage.items as NamedItem[]
        }
      }

      if (cancelled) return
      setLinks(homeCatalogLinks(eras, sampleSets, sampleCards, i18n.language, roots))
    }

    load().catch(() => {
      if (!cancelled) setLinks(emptyLinks)
    })

    return () => {
      cancelled = true
    }
  }, [i18n.language])

  const eraLinks = [{ href: SETS_INDEX_PATH, label: t('links.sets_index') }, ...links.eras]

  return (
    <div className="home-crawl-hub">
      <CrawlLinks label={ t('links.eras') } heading={ t('links.eras') } links={ eraLinks } />
      <CrawlLinks label={ t('links.sets') } heading={ t('links.sets') } links={ links.sets } />
      <CrawlLinks label={ t('links.cards') } heading={ t('links.cards') } links={ links.cards } />
    </div>
  )
}

export { HomeCrawlHub }
